// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"16a93bca","455":"1254685c","977":"603da246"}[chunkId] + ".chunk.js";
};